function isTimeExpired(time, duration) {
    return Date.now() - duration >= time;
}
export { isTimeExpired };
//# sourceMappingURL=helpers.js.map